<template v-slot:append>
  <v-dialog
    v-model="showDialog"
    max-width="90%"
    persistent
    no-click-animation>
    <v-card min-height="60%" min-width="90%">
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>契約に紐づく発注一覧</v-toolbar-title>
        <v-spacer></v-spacer>
        <dd-icon-button
          @click="onCloseClick"
          icon="mdi-close"/>
      </v-toolbar>

      <v-card-text>
        <v-container>
          <v-row no-gutters align-content="center">
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                <v-col :cols="6" class="px-1">
                  <dd-text-box
                    label="発注契約番号"
                    :length="10"
                    v-model="hacchuKeiyaku.hacchuKeiyakuNo"
                    ref="hacchuKeiyakuNo"
                    :valueType="Ctrls.InputTypes.Number"
                    :readonly="true"
                    dense/>
                </v-col>
                <v-col :cols="6" class="px-1">
                  <dd-text-box
                    label="契約名"
                    v-model="hacchuKeiyaku.keiyakuNm"
                    ref="keiyakuNm"
                    :valueType="Ctrls.InputTypes.Free"
                    :readonly="true"
                    dense/>
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                <v-col class="px-1">
                  <dd-code-text-box
                    label="支払先コード/名称"
                    v-model="hacchuKeiyaku.shiharaisakiCd"
                    ref="shiharaisakiCd"
                    :valueType="Ctrls.InputTypes.Free"
                    titleText="支払先検索"
                    item-value="torihikisakiCd"
                    item-text="torihikisakiNm"
                    :headerList="headersShiharaisakiList"
                    :itemList="filteredShiharaisakiList"
                    :readonly="true"
                    dense/>
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                <v-col :cols="4" class="px-1">
                  <dd-date-box
                    label="契約開始日"
                    v-model="hacchuKeiyaku.keiyakuStartYmdDisp"
                    ref="keiyakuStartYmd"
                    :readonly="true"
                    dense/>
                </v-col>
                <v-col :cols="4" class="px-1">
                  <dd-date-box
                    label="契約満了日"
                    v-model="hacchuKeiyaku.keiyakuEndYmdDisp"
                    ref="keiyakuEndYmd"
                    :readonly="true"
                    dense/>
                </v-col>
                <v-col :cols="4" class="px-1">
                  <dd-text-box
                    label="契約基本金額"
                    v-model="hacchuKeiyaku.keiyakuKihonKingaku"
                    ref="keiyakuKihonKingaku"
                    :valueType="Ctrls.InputTypes.Free"
                    :readonly="true"
                    dense/>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters class="spx" />
          <v-row no-gutters align-content="center">
            <v-col :cols="2"></v-col>
            <v-col :cols="10">
              <v-row no-gutters align-content="center">
                <v-col class="px-1">
                  <dd-text-box
                    label="支払先備考"
                    v-model="hacchuKeiyaku.hacchuKeiyakuBiko"
                    ref="hacchuKeiyakuBiko"
                    :valueType="Ctrls.InputTypes.Free"
                    :readonly="true"
                    dense/>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters class="spx" />

          <v-row no-gutters>
            <v-col :cols="12">
              <dd-data-table
                item-key="id"
                height="50vh"
                :headers="headers"
                :items="filteredHacchuRows"
                :search="searchText"
                :custom-filter="filtering"
                :page.sync ="page"/>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <dd-default-button
          elevation="2"
          class="mx-5"
          text
          outlined
          rounded
          dark
          style="background:#2F75B5;"
          min-width="100"
          @click="onCloseClick">
          閉じる
        </dd-default-button>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DdDataTable from '@/components/DdDataTable'
import DdTextBox from '@/components/DdTextBox'
import DdIconButton from '@/components/DdIconButton'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdDateBox from '@/components/DdDateBox'
import DdDefaultButton from '@/components/DdDefaultButton'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import header from '@/ddv2.library/header'

import { mapGetters } from 'vuex'

export default {
  name: 'DdV2JutyuKensakuDialog',
  mixins: [flowMixin],
  components: {
    DdDataTable,
    DdTextBox,
    DdIconButton,
    DdCodeTextBox,
    DdDateBox,
    DdDefaultButton
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * 発注契約ID
     */
    hacchuKeiyakuId: Number
  },
  data: () => ({
    hacchuKeiyaku: {
      hacchuKeiyakuNo: 0,
      keiyakuNm: '',
      shiharaisakiCd: '',
      keiyakuStartYmd: '',
      keiyakuEndYmd: '',
      keiyakuKihonKingaku: '',
      hacchuKeiyakuBiko: ''
    },
    hacchuListRows: [],
    headersShiharaisakiList: header.mstTorihikisakiHeaders,
    page: 1
    // headersShiharaisakiList: [
    //   { width: '60px', text: '支払先コード', value: 'shiharaisakiCd' },
    //   { width: '90px', text: '支払先名', value: 'shiharaisakiNm' }
    // ]
  }),
  created () {
  },
  mounted () {
    this.initialize()
  },
  computed: {
    ...mapGetters({
      torihikisakiList: 'DDMasters/vwCMstTorihikisakiGetShiharaisaki'
    }),
    filteredShiharaisakiList () {
      // 支払先はviewから取得する
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        return elem1.hyojiOrder - elem2.hyojiOrder
      })
    },
    computedProps () {
      return {
        ...this.$props,
        persistent: true
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    filteredHacchuRows () {
      return this.hacchuListRows.map((elem) => {
        console.log(elem)
        elem.hacchuYmdDisp = filter.dateFormatter(elem.hacchuYmd) ?? ''
        if (elem.sagyoYoteiYmd !== null) {
          elem.sagyoYoteiYmdDisp = filter.dateFormatter(elem.sagyoYoteiYmd) ?? ''
        }
        return elem
      })
    }
  },
  watch: {
    showDialog: function () {
      if (this.showDialog) {
        this.HttpClient
          .get(`/api/v1/VwCD2oicd0010/findById?id=${this.hacchuKeiyakuId}`)
          .then((data) => {
            this.hacchuKeiyaku = data.payload
            this.hacchuKeiyaku.keiyakuStartYmdDisp = filter.dateFormatter(data.payload.keiyakuStartYmd) ?? ''
            this.hacchuKeiyaku.keiyakuEndYmdDisp = filter.dateFormatter(data.payload.keiyakuEndYmd) ?? ''
          })
        this.HttpClient
          .post('/api/v1/VwCD2oicd0011/search', { HacchuKeiyakuId: this.hacchuKeiyakuId })
          .then((data) => {
            this.hacchuListRows = data.payload
          })
      }
    }
  },
  methods: {
    initialize: function () {
      const opt = {
        loadMasters: ['vwcmsttorihikisakigetshiharaisaki'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('hacchuListDialog.defineHeaderPromise')
            this.headers = [
              { width: '100px', text: '発注番号', value: 'hacchuNo' },
              { width: '80px', text: '発注日', value: 'hacchuYmdDisp' },
              { width: '120px', text: '発注営業所', value: 'eigyoshoNm' },
              { width: '200px', text: '取引先', value: 'torihikisakiNm' },
              { width: '80px', text: '発注明細番号', value: 'hacchuMeisaiNo' },
              { width: '80px', text: '作業予定日', value: 'sagyoYoteiYmdDisp', align: 'center' },
              { width: '150px', text: '荷主', value: 'ninushiNm' },
              { width: '150px', text: '発地', value: 'hatsuchiNm' },
              { width: '150px', text: '卸先', value: 'oroshisakiNm' },
              { width: '150px', text: '着地', value: 'chakuchiNm' }
            ]
            resolve()
          })
        },
        initializeInputPromise: this.clear(),
        savedInputRestorePromise: (c) => {
          console.log('hacchuListDialog.savedInputRestorePromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        researchPromise: (c) => {
          console.log('hacchuListDialog.researchPromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('hacchuListDialog.restoreViewPromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('hacchuListDialog.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            resolve()
          })
        },
        getCloneTargetMethod: function () {
          return {
            hacchuKeiyaku: this.hacchuKeiyaku
          }
        }
      }
      this.initializeForViewer(opt)
    },
    clear: function () {
      console.log('clear')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.hacchukeiyaku = {
              hacchuKeiyakuNo: 0,
              keiyakuNm: '',
              shiharaisakiCd: '',
              keiyakuStartYmd: '',
              keiyakuEndYmd: '',
              keiyakuKihonKingaku: '',
              hacchuKeiyakuBiko: ''
            }
            self.hacchuListRows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onCloseClick: function (e) {
      console.log('close clicked', this.showDialog)
      this.clear()
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
  .spx{
    height: 10px;
  }
</style>
